import { useMemo } from "react";
import { BillingService } from "@/services/BillingService";
import { isApiErrorStatus } from "@/api/ApiError";
import { useQuery } from "@tanstack/react-query";

export function useBillingSummaryQuery(enabled: boolean = true) {
  const billingService = useMemo(() => new BillingService(), []);

  return useQuery({
    queryKey: ["billing-summary"],
    queryFn: () => billingService.getMyBillingSummary(),
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    // A 404 means the endpoint isn't live (e.g. frontend deployed ahead of the
    // backend) — retrying just delays the "temporarily unavailable" message, so
    // fail fast on it. Other failures keep the exponential-backoff retries.
    retry: (failureCount, error) => !isApiErrorStatus(error, 404) && failureCount < 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff up to 30 seconds
  });
}
